import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Release } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiReleaseService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(projectId: number): void {
    this.fetch(projectId).subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(projectId: number): Observable<Release[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/release/${projectId}`))
      .pipe(
        map((response: any, i) => {
          // console.log('fetch:map:response: ', response, i);
          // let returning =<Release[]>response; // response.map(r =>  Release.create((r)));
          // console.log('fetch:map:response: ', returning);
          return <Release[]>response;
        }),
        map(r => r.map(x => Release.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReleaseService extends CasiReleaseService{

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('release', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`release/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('release', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`release/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`release/${id}`, 'destroy');
  }

  fetchForRelease(projectId: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`forrelease/${projectId}`, 'fetchForRelease');
  }

  addAssign(release: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`release/assign`, {release}, 'addAssignRelease');
  }

  fetchReleaseDetails(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`releasedetails/${id}`, 'fetchReleaseDetails');
  }

}
